export default __webpack_public_path__ + "static/hw_ff_potentiometer-9c1766f0bef63fb52dfae25f897e9b33.png";